<div class="mb-3">
  <div class="form-group col-12">
    <div class="row">
      <div class="col-12"
           [innerHTML]="translationService.getTranslation('name') + ': ' + joinParts([person.addressCodeDescription, person.titleDescription, person.firstname, person.lastname])"></div>
    </div>
  </div>
  <div class="form-group col-12">
    <div class="row">
      <div class="col-12"
           [innerHTML]="translationService.getTranslation('address_street') + ': ' + joinParts([address.street, address.houseno | houseNoPipe])"></div>
    </div>
  </div>
  <div class="form-group col-12">
    <div class="row">
      <div class="col-12"
           [innerHTML]="translationService.getTranslation('address_postcode') + ': ' + joinParts([address.zipcode])"></div>
    </div>
  </div>
  <div class="form-group col-12">
    <div class="row">
      <div class="col-12"
           [innerHTML]="translationService.getTranslation('address_city') + ': ' + joinParts([address.city, address.countryDescription], ', ')"></div>
    </div>
  </div>
</div>
